import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { PlayerMutationKeys } from '../../../keys'
import { UpdatePlayerRequest, UpdatePlayerResponse } from '../../../type'
import { updatePlayer } from '../../services'

interface UseMutationUpdatePlayerProps {
	id: string
	payload: UpdatePlayerRequest
}

export default function useMutationUpdatePlayer(
	props?: UseBaseMutationOptions<
		UpdatePlayerResponse,
		UseMutationUpdatePlayerProps
	>,
) {
	return useMutation({
		mutationKey: [PlayerMutationKeys.UpdatePlayer],
		mutationFn: ({ id, payload }) => {
			return updatePlayer(id, payload)
		},
		...props,
	})
}
